import { z } from 'zod';

export const cropBatchResultItemSchema = z.object({
  clipId: z.number(),
  jobId: z.number().nullable(),
  status: z.enum(['enqueued', 'duplicate']),
});

export const cropBatchResponseSchema = z.object({
  accepted: z.boolean(),
  count: z.number(),
  items: z.array(cropBatchResultItemSchema),
});

export type ICropBatchResultItem = z.infer<typeof cropBatchResultItemSchema>;
export type ICropBatchResponse = z.infer<typeof cropBatchResponseSchema>;
